import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const FilterItem = ({ label, value, active, title, titleGenitive, onSelect }) =>
	title ? (
		<button
			className={cx(styles.FilterItem, {
				[styles.FilterItem_active]: active
			})}
			onClick={() => onSelect({ label, value, titleGenitive })}
			type="button"
		>
			{title}
		</button>
	) : null;

FilterItem.propTypes = {
	label: PropTypes.node,
	value: PropTypes.string,
	titleGenitive: PropTypes.string,
	title: PropTypes.string,
	active: PropTypes.bool,
	onSelect: PropTypes.func
};

FilterItem.defaultProps = {
	active: false
};
export default FilterItem;
